import {
  type DataLayerArgs
} from 'react-gtm-module';
import {
  ENVIRONMENT
} from '@shared/config';
import {
  GTM_ID_8847
} from '../config'

const initializedGtmIds = new Set<string>();

export type PushToGtmOptions = {
  gtmId?: string;
  auth?: string;
  preview?: string;
  dataLayerName?: string;
};

export const pushToGtm = async (
  data: DataLayerArgs,
  options: PushToGtmOptions = {}
): Promise<void> => {
  if (ENVIRONMENT !== 'prod') return;

  const TagManager = await import('react-gtm-module');
  const gtmId = options?.gtmId || GTM_ID_8847;

  if (!gtmId) {
    console.warn('No GTM ID provided, and GTM_ID is undefined');
    return;
  }

  if (!initializedGtmIds.has(gtmId)) {
    TagManager.default.initialize({ gtmId, ...options });
    initializedGtmIds.add(gtmId);
  }

  TagManager.default.dataLayer({ ...data });
};
